import React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Drawer, Input } from 'antd';
import { FormComponentProps } from '@ant-design/compatible/es/form';
import {
  useUpdateVehicleBrandMutation,
  useGetVehicleBrandQuery,
  GetVehicleBrandQuery,
} from '../../../graphql/datamodel.gen';
import { getClient } from '../../../apollo';
import _ from 'lodash';

interface IProps {
  visible: boolean;
  onClose: () => any;
  brandId: string;
}

interface IForm extends FormComponentProps {
  onSubmit: (brand: string) => Promise<any>;
  onClose: () => any;
  brand: GetVehicleBrandQuery['vehicleBrand'];
}
interface IFormState {
  loading: boolean;
}

class UpdateBrandForm extends React.Component<IForm, IFormState> {
  state = {
    loading: false,
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values: { name: string }) => {
      if (!err) {
        try {
          this.setState({
            loading: true,
          });
          await this.props.onSubmit(values.name);
          this.setState({
            loading: false,
          });
          this.props.onClose();
        } finally {
          this.setState({
            loading: false,
          });
        }
      }
    });
  };

  render() {
    return (
      <Form onSubmit={this.handleSubmit} layout="vertical">
        <Form.Item required={true} label={'Nombre de la marca'}>
          {this.props.form.getFieldDecorator('name', {
            initialValue: this.props.brand.brand,
            rules: [
              {
                required: true,
              },
            ],
          })(<Input placeholder={'Por ej: Mercedes'} />)}
        </Form.Item>
        <Form.Item>
          <Button
            loading={this.state.loading}
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            Guardar cambios
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const MyUpdateBrandForm = Form.create<IForm>()(UpdateBrandForm);

const UpdateBrand: React.FC<IProps> = (props: IProps) => {
  const vehicleBrandQuery = useGetVehicleBrandQuery({
    client: getClient(),
    variables: {
      id: props.brandId,
    },
    fetchPolicy: 'network-only',
  });

  const [updateVehicleBrandMut] = useUpdateVehicleBrandMutation({
    client: getClient(),
  });

  const updateVehicleBrand = (brand: string) => {
    return updateVehicleBrandMut({
      variables: {
        name: brand,
        id: props.brandId,
      },
      // update: (proxy, mutationResult) => {
      //   try {
      //     const previousData = getClient().readQuery<
      //       GetVehicleBrandModelsQuery,
      //       VehicleBrandModelsQueryVariables
      //     >({
      //       query: VehicleBrandModelsDocument,
      //     });
      //
      //     const newData = _.cloneDeep([
      //       ...previousData.vehicleBrandModels.filter(
      //         brand => brand.id === props.brandId,
      //       ),
      //       mutationResult.data.updateVehicleBrand,
      //     ]);
      //
      //     getClient().writeQuery({
      //       query: VehicleBrandModelsDocument,
      //       data: {
      //         vehicleBrandModels: newData,
      //       },
      //     });
      //   } catch (e) {
      //     getClient().writeQuery({
      //       query: VehicleBrandModelsDocument,
      //       data: {
      //         vehicleBrandModels: [mutationResult.data.updateVehicleBrand],
      //       },
      //     });
      //   } finally {
      //     getClient().queryManager.broadcastQueries();
      //   }
      // },
    });
  };

  return (
    <Drawer
      maskClosable={true}
      closable={true}
      width={300}
      visible={props.visible}
      onClose={props.onClose}
      destroyOnClose={true}
    >
      {vehicleBrandQuery?.data?.vehicleBrand && (
        <MyUpdateBrandForm
          brand={vehicleBrandQuery?.data?.vehicleBrand}
          onSubmit={updateVehicleBrand}
          onClose={props.onClose}
        />
      )}
    </Drawer>
  );
};

export default UpdateBrand;
